import {combineReducers} from 'redux'
import {reducer as reduxFormReducer} from 'redux-form'
import {cartReducer} from './Cart'
import {tokenReducer} from './Token'
import {articleDataReducer} from './ArticleData'
import {domainCheckReducer} from './DomainCheck'
import {uiReducer} from './UserInterface'
import {clientDataStepReducer} from './ClientData'
import {paymentStepReducer} from './PaymentStep'
import {appStateReducer} from './AppState'
import {collapsibleContentReducer} from './Collapsibles'
import {toggleSelectionReducer} from './ToggleSelections'
import {recommendedAccountTypesReducer} from './RecAccountTypes'
import {softwareReducer} from './Software'
import {databaseReducer} from './Database'
import {promotionCodeReducer} from './PromotionCode'
import {contentPopupReducer} from './ContentPopup'
import * as storage from 'redux-storage'
import {propertiesReducer} from "./Properties";
import {accountsReducer} from "./Accounts";
import {resellersReducer} from "./Resellers";
import {productSelectionReducer} from "./ProductSelection";
import {contractsReducer} from "./Contracts";
import {outsourcingReducer} from "./Outsourcing";
import {mappingsReducer} from "./Mappings";


// **************************************************************************************************************
const rootReducer = combineReducers({
    token: tokenReducer,
    articleData: articleDataReducer,
    cart: cartReducer,
    properties: propertiesReducer,
    form: reduxFormReducer,
    ui: uiReducer,
    appState: appStateReducer,
    domainCheck: domainCheckReducer,
    clientDataStep: clientDataStepReducer,
    paymentStep: paymentStepReducer,
    contentPopup: contentPopupReducer,
    collapsibles: collapsibleContentReducer,
    toggleSelections: toggleSelectionReducer,
    software: softwareReducer,
    mappings: mappingsReducer,
    promotionCode: promotionCodeReducer,
    database: databaseReducer,
    accounts: accountsReducer,
    resellers: resellersReducer,
    contracts: contractsReducer,
    outsourcing: outsourcingReducer,
    productSelection: productSelectionReducer,
    recommendedAccountTypes: recommendedAccountTypesReducer,
})

export default storage.reducer(rootReducer)



/** WEBPACK FOOTER **
 ** ./src/reducers/index.js
 **/